import React from "react";
import styles from "../../../../assets/styles/components/Suggestion.module.scss";

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------
export type KeywordMatchType = "EXACT" | "PHRASE" | "BROAD";

export type KeywordSuggestion = {
  keyword_id: string;
  text: string;
  match_type: KeywordMatchType;
  reason?: string; // なぜ除外を推奨するのか
};

type Props = {
  keywords: KeywordSuggestion[];
  formData: Record<string, boolean>; // keyword_id: true=維持, false=除外
  onChange: (id: string, checked: boolean) => void;
};

const MATCH_TYPE_LABEL: Record<KeywordMatchType, string> = {
  EXACT: "完全一致",
  PHRASE: "フレーズ一致",
  BROAD: "部分一致",
};

// -----------------------------------------------------------------------------
// Component: TargetingKeywordForm
// -----------------------------------------------------------------------------
const TargetingKeywordForm: React.FC<Props> = ({ keywords, formData, onChange }) => {
  return (
    <div className={styles.keywordFormContainer}>
      {keywords.map((kw) => {
        const isMaintained = formData[kw.keyword_id] ?? false;

        return (
          <section key={kw.keyword_id} className={styles.campaignCard}>
            <div className={styles.campaignName}>
              {kw.text}
              <span className={styles.keywordCountLabel}>
                ({MATCH_TYPE_LABEL[kw.match_type]})
              </span>
            </div>

            {kw.reason && (
              <div className={styles.reasonBar}>
                <strong>Aibex提案理由:</strong> {kw.reason}
              </div>
            )}

            <div className={styles.suggestionBox}>
              {/* Before */}
              <div className={styles.beforePanel}>
                <div className={styles.panelTitle}>現在の設定</div>
                <div className={styles.displayRow}>
                  <div className={`${styles.statusBadge} ${styles.bgOn}`}>
                    配信中
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className={styles.arrowIcon}>→</div>

              {/* After */}
              <div className={styles.afterPanel}>
                <div className={styles.panelTitle}>AI提案</div>
                <div className={styles.inputRow}>
                  <label className={styles.checkboxSwitch}>
                    <input
                      type="checkbox"
                      checked={isMaintained}
                      onChange={(e) => onChange(kw.keyword_id, e.target.checked)}
                    />
                    <span className={styles.slider}></span>
                  </label>
                  <div className={`${styles.statusBadge} ${isMaintained ? styles.bgOn : styles.bgOff}`}>
                    {isMaintained ? "維持 (配信)" : "除外 (停止)"}
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default TargetingKeywordForm;
